import Colors from '../../../../Configs/colors';

const styles = {
  root: {
    boxSizing: 'border-box',
    paddingBottom: 120,
    height: '100vh',
    overflow: 'auto',
    '& .bid-field': {
      '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: `${Colors.redLight} !important`,
        borderWidth: 1,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderRadius: 8,
        borderColor: `${Colors.redLight} !important`,
        // color: 'red',
      },
      '& .MuiOutlinedInput-input': {
        padding: 0,
      },
      // '& ::placeholder': {
      //   color: colors.black1,
      //   fontWeight: 'light',
      //   fontFamily: 'avenir',
      // },
      '& .MuiInputBase-root': {
        // color: colors.black1,
        // background: colors.white,
        // padding: '4px 4px',
        borderRadius: 8,
      },
    },
    // '& .bid-field': {
    //   border: 'none !important',
    //   outline: 'none !important',
    // },
    // '& .MuiTextField-root.bid-field .MuiInputBase-root': {
    //   border: `1px solid ${Colors.redLight} !important`,
    //   borderRadius: 8,
    // },
    // '& .MuiTextField-root.bid-field .MuiInputBase-input': {
    //   border: 'none !important',
    //   outline: 'none !important',
    //   paddingLeft: '2px !important',
    //   fontWeight: 'bold',
    //   noBorder: {
    //     border: 'none',
    //   },
    // },
    // '& .MuiTextField-root.bid-field .Mui-focused.MuiInputBase-input': {
    //   border: 'none !important',
    //   outline: 'none !important',
    //   paddingLeft: '2px !important',
    //   fontWeight: 'bold',
    // },
    '& .floating-action': {
      backgroundColor: '#fff',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      paddingBottom: 8,
      paddingTop: 8,
      boxShadow: '-1px -1px 4px rgba(0, 0, 0, 0.04)',
      border: '1px solid #F3F3F3',
    },
  },
};

export default styles;
